import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-masterclass-threshold-modal',
  templateUrl: './masterclass-threshold-modal.component.html',
  styleUrls: ['./masterclass-threshold-modal.component.scss']
})
export class MasterclassThresholdModalComponent implements OnInit {
  @Input() user:User;
  @Input() isWaitPoup:boolean;
  @Output() hideModal = new EventEmitter();
  @Output() hidePreModal = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  closeModal() {
    this.hideModal.emit(false);
  }

  closePreModal() {
    this.hidePreModal.emit(false);
  }

}
